import React from 'react';
import logoDark from '../assets/brand/spot-engine-logo-dark.svg';   // dark ink wordmark — for LIGHT backgrounds
import logoLight from '../assets/brand/spot-engine-logo-light.svg'; // light wordmark — for DARK backgrounds
import iconMark from '../assets/brand/spot-engine-icon.svg';
import styles from './Brand.module.css';

interface BrandProps {
  /** `full` shows the wordmark logo; `mark` shows only the icon (collapsed sider). */
  variant?: 'full' | 'mark';
  /** Background the brand sits on — picks the readable logo variant. */
  context?: 'light' | 'dark';
  /** Deprecated co-branding name; ignored (the product is engine-only now). */
  client?: string;
}

/**
 * Spot.Engine brand mark. Uses the designer's official logo assets so the sider,
 * mobile drawer, login, and favicon all stay in sync.
 */
const Brand: React.FC<BrandProps> = ({ variant = 'full', context = 'dark' }) => {
  if (variant === 'mark') {
    return <img src={iconMark} alt="Spot.Engine" className={styles.mark} />;
  }
  const src = context === 'light' ? logoDark : logoLight;
  return <img src={src} alt="Spot.Engine" className={styles.logo} />;
};

export default Brand;
